module.exports = __webpack_public_path__ + "static/media/1026929.6a0080bf.jpg";